import {CONFIG} from "../../config";
import axios from "axios";

async function ResetPasswordQuery(id) {
    const location = CONFIG.API_URL + "user/reset-password/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.post(location, settings);
    } catch (e) {
        return e;
    }
}

export default ResetPasswordQuery;